import React from "react";
import IndicatorFields from "src/pages/Indicators/Fields";
import Indicators from "src/pages/Indicators/Indicators";
import IndicatorsHierarchy from "src/pages/Indicators/Hierarchy";
import IndicatorsPanel from "src/pages/Indicators/Panel";
import IndicatorsPresentationGroup from "src/pages/Indicators/PresentationGroup";
import IndicatorsPresentationPanel from "src/pages/Indicators/PresentationPanel";
import IndicatorsPresentationPanelSelected from "src/pages/Indicators/PresentationPanelSelected";

import ValuesImport from "src/pages/Indicators/Import/Index";
import ValuesImportLogs from "src/pages/Indicators/Logs/Index";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/indicators/fields" key="indicatorsFields" exact component={IndicatorFields} isPrivate/>,
	<RoutePrivate path="/indicators" key="indicators" exact component={Indicators} isPrivate/>,
	<RoutePrivate path="/indicators/hierarchy" key="indicatorsHierarchy" exact component={IndicatorsHierarchy} isPrivate/>,
	<RoutePrivate path="/indicators/panel" key="indicatorsPanel" exact component={IndicatorsPanel} isPrivate/>,
	<RoutePrivate path="/indicators/panel/:indicatorId" permissionPath="/indicators/panel" key="indicatorsPanelIndicatorId" exact component={IndicatorsPanel} isPrivate/>,
	<RoutePrivate path="/indicators/presentationgroups" key="presentationgroups" exact component={IndicatorsPresentationGroup} isPrivate/>,
	<RoutePrivate path="/indicators/presentation" key="indicatorsPresentationPanel" exact component={IndicatorsPresentationPanel} isPrivate/>,
	<RoutePrivate path="/indicators/presentation/selected/:indicatorsId" key="indicatorsPresentationSelected" exact component={IndicatorsPresentationPanelSelected} checkPermission={false} />,
	<RoutePrivate path="/indicators/valuesimport" key="ValuesImport" exact component={ValuesImport} isPrivate/>,
	<RoutePrivate path="/indicators/valueslog" permissionPath="/indicators/valuesimport" key="valuesLog" exact component={ValuesImportLogs} isPrivate/>
];
